(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@regang/keen-core"), require("component-emitter"));
	else if(typeof define === 'function' && define.amd)
		define(["@regang/keen-core", "component-emitter"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("@regang/keen-core"), require("component-emitter")) : factory(root["@regang/keen-core"], root["component-emitter"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(global, function(__WEBPACK_EXTERNAL_MODULE__10__, __WEBPACK_EXTERNAL_MODULE__11__) {
return 